import {
  Box,
  Flex,
  Text,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { BasicValue } from "@/models/Plan";
import { useEffect, useState, KeyboardEvent } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { formatCurrency, formatCurrencyToApi, currency } from "@/utils";
import { Tooltip, Input as InputBarte } from "barte-design-system";
interface PeriodicityProps {
  basicValues?: BasicValue[];
  errors?: any;
  register?: any;
  watch?: any;
  setValue?: any;
}

const Periodicity = ({
  basicValues,
  setValue,
  watch,
  errors,
  register,
}: PeriodicityProps) => {
  const [periodicityTypes, setPeriodicityTypes] = useState([
    {
      type: "MONTHLY",
      title: "Mensal",
      value: 0,
      valuePerMonth: 0,
      periodicity: 1,
    },
    {
      type: "SEMESTER",
      title: "Semestral",
      value: 0,
      valuePerMonth: 0,
      periodicity: 6,
    },
    {
      type: "YEARLY",
      title: "Anual",
      value: 0,
      valuePerMonth: 0,
      periodicity: 12,
    },
  ]);

  function handlePeriodicityErrors(type: string) {
    if (type === "MONTHLY" && errors?.monthly) return errors?.monthly?.message;
    if (type === "SEMESTER" && errors?.semester)
      return errors?.semester?.message;
    if (type === "YEARLY" && errors?.yearly) return errors?.yearly?.message;
  }

  function handlePeriodicityPaymentValue(type: string, value: number) {
    if (type === "MONTHLY") return formatCurrency({ value: value });
    if (type === "SEMESTER") return formatCurrency({ value: value * 6 });
    if (type === "YEARLY") return formatCurrency({ value: value * 12 });
  }

  useEffect(() => {
    if (basicValues.length > 0) {
      setPeriodicityTypes(
        periodicityTypes.map((periodicityType) => {
          const finded = basicValues.find(
            (basicValue) =>
              basicValue.type === periodicityType.type && basicValue.value !== 0
          );
          if (finded) {
            return {
              ...periodicityType,
              value: finded.value,
              valuePerMonth: finded.value / periodicityType.periodicity,
            };
          }
          return periodicityType;
        })
      );
    }
  }, [basicValues]);

  useEffect(() => {
    setValue(
      "monthly",
      formatCurrency({
        style: null,
        value: periodicityTypes[0]?.valuePerMonth,
      })
    );
    setValue(
      "semester",
      formatCurrency({
        style: null,
        value: periodicityTypes[1]?.valuePerMonth,
      })
    );
    setValue(
      "yearly",
      formatCurrency({
        style: null,
        value: periodicityTypes[2]?.valuePerMonth,
      })
    );
  }, [periodicityTypes]);

  return (
    <Box w="100%">
      <Flex mb="1rem" align="center">
        <Text
          color="var(--content-primary)"
          fontSize="14px"
          marginRight=".4rem"
          fontWeight="bold"
        >
          Valores por periodicidade
        </Text>
        <Tooltip
          placement="right"
          label="Exibimos os valores por mês mas a cobrança
          é realizada de acordo com a periodicidade."
        >
          <span>
            <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
          </span>
        </Tooltip>
      </Flex>
      <Box w="100%">
        <VStack w="100%" spacing={6} align="stretch" flexDir="column">
          {periodicityTypes.map(({ type, title }) => {
            const fieldError = handlePeriodicityErrors(type);
            const helperText =
              title !== "Mensal"
                ? `Pagamento ${title}: ${
                    watch(type.toLowerCase()) === ""
                      ? "R$ 0,00"
                      : handlePeriodicityPaymentValue(
                          type,
                          formatCurrencyToApi(watch(type.toLowerCase()))
                        )
                  }`
                : undefined;

            return (
              <Flex
                key={type}
                direction="column"
                w="100%"
                gap="var(--spacing-sm)"
              >
                <Text
                  as="label"
                  color="var(--content-primary)"
                  fontSize="14px"
                  fontWeight="500"
                >
                  {title}
                </Text>

                <Box position="relative" w="100%">
                  <InputBarte
                    type="text"
                    {...register(type.toLowerCase())}
                    style={{
                      paddingLeft: "44px",
                      paddingRight: "56px",
                    }}
                    onKeyDown={(e: any) => {
                      const isNumber = isFinite(e.key);
                      if (isNumber) {
                        currency(e, true);
                      }
                    }}
                  />
                  <Flex
                    position="absolute"
                    left="12px"
                    top="0"
                    bottom="0"
                    align="center"
                    zIndex={2}
                    pointerEvents="none"
                    color="var(--content-tertiary)"
                  >
                    R$
                  </Flex>
                  <Flex
                    position="absolute"
                    right="12px"
                    top="0"
                    bottom="0"
                    align="center"
                    zIndex={2}
                    pointerEvents="none"
                    color="var(--content-tertiary)"
                  >
                    /mês
                  </Flex>
                </Box>

                {helperText && (
                  <Text color="var(--content-tertiary)" fontSize="12px">
                    {helperText}
                  </Text>
                )}

                {fieldError && (
                  <Text color="danger" fontSize="12px" role="alert">
                    {fieldError}
                  </Text>
                )}
              </Flex>
            );
          })}
        </VStack>
      </Box>
    </Box>
  );
};

export { Periodicity };
